import React, { Component } from "react";
import PropTypes from "prop-types"; 
import * as qs from "query-string";
import { withRouter, Link } from "react-router-dom";
import { createBrowserHistory } from "history";
import { browserHistory } from "react-router";
import Pagination from "react-paginating";
import isEmpty from "lodash.isempty";
import Dialog from "react-bootstrap-dialog";
import { compose } from "redux";
import {
  tr,
  th,
  td,
  thead,
  Table,
  div,
  tbody,
  Button,
  Alert,
  FormGroup,
  InputGroup,
  FormControl,
  Modal,
  ControlLabel,
  DropdownButton,
  MenuItem,
  ButtonGroup,
} from "react-bootstrap";

import { NewBreadcrumb as BreadcrumbComponent } from "../../../../components";
import Toggle from "react-bootstrap-toggle";
import "../../../../style/listPage.scss";
import {aclUtil} from "../../../util"

const history = createBrowserHistory();
let isLoading = "false",
  ParentCatID = "",
  SubCatID = "";
class view extends Component {
  static contextTypes = {
    router: PropTypes.object
  }
  constructor(props) {
    const viewLink = (props.match && props.match.params) && `viewcategories/${props.match.params.catID}` && `viewcategories/${props.match.params.catID}/${props.match.params.subcatID}`
    super(props);
    this.state = {
      menuKey: 'VIEW_CATEGORY',
      catList: [],
      no: 0,
      activePage: 1,
      msg_status: "hide",
      path: ["Home", "Manage Categories","View"],
      links:["home", "categories", viewLink],
      totalRecords: 0,
      limit: 10,
      search: "",
      perPage: 0,
      pageCount: 0,
      alertMessage: "",
      show: "false",
      categoryStatus: {},
      multi_lang: 'no',
    };

    this.handleDismiss = this.handleDismiss.bind(this);
    this.handleShow = this.handleShow.bind(this);
  }

  handleDismiss() {
    this.setState({ show: false });
  }

  handleShow() {
    this.setState({ show: true });
  }

  handleSearch = () => e => {
    const searchString = e.target.value;
    const {
      actions: { getCategoryById }
    } = this.props;
    if (searchString.length > 0) {
      getCategoryById(SubCatID, this.state.activePage, searchString);
    } else {
      getCategoryById(SubCatID, this.state.activePage, "");
    }

    this.setState({ searchString: searchString });
  };

  componentWillMount() {
    let siteData = JSON.parse(localStorage.getItem('siteDDBStatus'));

    if(siteData){
      if(siteData.multi_lang){
        this.setState({
          multi_lang: siteData.multi_lang
        });
      }
    } 
    if(this.props.match.params.subcatID)
    {
      ParentCatID = this.props.match.params.catID
      ? this.props.match.params.catID
      : "";
      SubCatID = this.props.match.params.subcatID
      ? this.props.match.params.subcatID
      : "";
      if (ParentCatID && SubCatID) {
        const {
          actions: { getSubCategories }
        } = this.props;
        getSubCategories(ParentCatID, SubCatID);
      }
    }
    else
    {
      SubCatID = this.props.match.params.catID
      ? this.props.match.params.catID
      : "";
      if (SubCatID) {
        const {
          actions: { getCategoryById }
        } = this.props;
        getCategoryById(SubCatID, this.state.activePage);
      }
    } 
  }

  componentWillReceiveProps(nextProps) { 
    if(!aclUtil.isPrimaryMenuAccessible(this.state.menuKey)){
      this.context.router.history.push("/restrictedAccess");
    }

    if (this.props.catList !== nextProps.catList) {
      let categoryStatusObject = new Object();
      if (typeof nextProps.catList != "undefined") {
        let setPageCount =
          nextProps.catList.data.total / nextProps.catList.data.per_page;
        this.setState({ catList: nextProps.catList.data.data });
        this.setState({ totalRecords: nextProps.catList.data.total });
        this.setState({ perPage: nextProps.catList.data.per_page });
        this.setState({ pageCount: setPageCount, currentPage: nextProps.catList.data.current_page  });
        if (nextProps.catList.data.data) {
          nextProps.catList.data.data.map((cat, index) => {
            const id = cat.catID;
            if (cat.status == "Active") {
              categoryStatusObject[id] = true;
            } else if (cat.status === "Inactive") {
              categoryStatusObject[id] = false;
            }
          });
        }
        this.setState({ categoryStatus: categoryStatusObject });
      }
    }

    if (this.props.deleteStatus !== nextProps.deleteStatus) {
      const {
        actions: { clearAlerts }
      } = this.props;
      clearAlerts();
      this.handleShow();
      const {
        actions: { renderAlerts }
      } = this.props;
      renderAlerts("success", nextProps.deleteStatus.message);
      const {
        actions: { getCategoryById }
      } = this.props;
      getCategoryById(SubCatID, this.state.activePage);
    }
    if (this.props.catStatus !== nextProps.catStatus) {
      isLoading = "false";
      const {
        actions: { clearAlerts }
      } = this.props;
      clearAlerts();
      this.handleShow();
      const {
        actions: { renderAlerts }
      } = this.props;
      renderAlerts("success", nextProps.catStatus.message);
      const {
        actions: { getCategoryById }
      } = this.props;
      getCategoryById(SubCatID, this.state.activePage);
    }

    if (this.props.message !== nextProps.message) {
      if (nextProps.message) {
        this.setState({
          alertMessage: nextProps.message,
          msgType: nextProps.alertType
        });
      }
    }
  }

  deleteCategory = catID => {
    this.dialog.show({
      body: "Are you sure you want to delete this?",
      actions: [
        Dialog.CancelAction(),
        Dialog.OKAction(() => {
          this.confirmDelete(catID);
          this.handleShow();
        })
      ]
    });
  };

  confirmDelete = catID => {
    const {
      actions: { deleteCategory }
    } = this.props;
    deleteCategory(catID);
    const {
      actions: { getCategoryById }
    } = this.props;
    getCategoryById(SubCatID, this.state.activePage);
  };

  changeStatus = (catID, status) => {
    this.handleShow();
    isLoading = "true";
    let updateStatus = "";
    if (status === "Active") {
      updateStatus = "Inactive";
    } else if (status === "Inactive") {
      updateStatus = "Active";
    }
    const {
      actions: { statusCategory }
    } = this.props;
    statusCategory(catID, updateStatus);
  };

  handlePageChange = pageNumber => {
    this.setState({ activePage: pageNumber }); 
    const {
      actions: { getCategoryById }
    } = this.props;
    getCategoryById(SubCatID, pageNumber, "", this.state.limit);
  };

  render() {
    const { currentPage, totalRecords, perPage, pageCount } = this.state;

    let contentRow;
    if (!isEmpty(this.state.catList)) {
      contentRow = this.state.catList.map((cat, index) => (
        <tr key={cat.catID}>
          <td>{cat.catName}</td>
          {(this.state.multi_lang == "yes") &&
          <td>{cat.french_catName}</td>
          }
          <td>{cat.catType}</td>
          {aclUtil.checkACL('STATUS_CATEGORY') ? (<td>
            <Toggle
              on={"Active"}
              off={"Inactive"}
              size="lg"
              responsive="true"
              offstyle="default"
              onstyle="success"
              height="30px"
              width="100px"
              active={this.state.categoryStatus[cat.catID]}
              onClick={this.changeStatus.bind(this, cat.catID, cat.status)}
            />
          </td>) :("")}
          <td>
            <ButtonGroup>
              <DropdownButton title="Action" id="bg-nested-dropdown">
                {aclUtil.checkACL('VIEW_CATEGORY') && cat.type!="Second-sub-category" ? (<MenuItem eventKey={Math.random()} onClick={() => this.context.router.history.push(`/viewcategories/${cat.parentID}/${cat.catID}`)}><i className="glyphicon glyphicon-eye-open"></i> View</MenuItem>) : ("")}
                {aclUtil.checkACL('EDIT_CATEGORY') ? (<MenuItem eventKey={Math.random()} onClick={() => this.context.router.history.push(`/addCategory/${cat.catID}`)}><i className="glyphicon glyphicon-pencil"></i> Edit</MenuItem>) : ("")}
                {aclUtil.checkACL('DELETE_CATEGORY') ? (<MenuItem eventKey={Math.random()} onClick={this.deleteCategory.bind(this, cat.catID)}><i className="glyphicon glyphicon-trash"></i> Delete</MenuItem>) : ("")}
              </DropdownButton>
            </ButtonGroup>
          </td>
        </tr>
      ));
    } else {
      contentRow = (
        <tr>
          <td>
            {" "}
            <span style={{ color: "red" }}>
              No Sub category created for this category!{" "}
            </span>{" "}
          </td>
        </tr>
      );
    }

    return (
      <div className="col-xs-12 list-page">
        {isLoading == "true" ? (
          <div className="loader">
            <p className="loading-message">
              <i>Loading...</i>
            </p>
            <div className="spinner">
              <div className="dot1" />
              <div className="dot2" />
            </div>
          </div>
        ) : (
          ""
        )}
        <Dialog
          ref={el => {
            this.dialog = el;
          }}
        />

        <div className="col-lg-12 user-list">
          <div className="row">
            <div className="col-xs-12">
              <BreadcrumbComponent path={this.state.path} links={this.state.links} context={this.context}/>
            </div>
          </div>
          <div className="panel">
            <header className="panel-heading">SubCategory List</header>
            <div className="panel-body">
              {this.state.show &&
                this.state.alertMessage !== "" && (
                  <div className="col-lg-12">
                    <Alert
                      bsStyle={this.state.msgType}
                      onDismiss={this.handleDismiss}
                    >
                      <strong>{this.state.msgType}:</strong>{" "}
                      {this.state.alertMessage}
                    </Alert>
                  </div>
                )}
              <div className="row">
                <div className="col-lg-12 text-right">
                  <Button
                    bsSize="small"
                    bsStyle="success"
                    onClick={() => this.context.router.history.push("/categories")}
                  >
                    Back
                  </Button>
                </div>
              </div>
              <div className="clearfix" />
              <div className="row m-t-15">
                <div className="col-lg-4 pull-right">
                  <FormGroup>
                    <InputGroup>
                      <FormControl
                        type="text"
                        name="search"
                        onKeyUp={this.handleSearch()}
                      />
                      <InputGroup.Addon>
                        <i className="glyphicon glyphicon-search" />
                      </InputGroup.Addon>
                    </InputGroup>
                  </FormGroup>
                </div>
              </div>
              <div className="row">
                <div className="col-lg-12">
                  <table className="table table-hover">
                    <thead>
                      <tr>
                        <th>Category Name </th>
                        {(this.state.multi_lang == "yes") &&
                          <th >
                            {" "}
                            Category Name (Canadian French){" "}
                          </th>
                        }
                        <th>Category Type</th>

                        {aclUtil.checkACL('STATUS_CATEGORY') ? (<th>Status</th>) :("")}
                        <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody>{contentRow}</tbody>
                  </table>

                  <div className="text-center">
                    <Pagination
                      total={totalRecords}
                      limit={perPage}
                      pageCount={5}
                      currentPage={currentPage}
                    >
                      {({
                        pages,
                        currentPage,
                        hasNextPage,
                        hasPreviousPage,
                        previousPage,
                        nextPage,
                        totalPages,
                        getPageItemProps
                      }) => (
                        <div className="pagination">
                          <button
                            {...getPageItemProps({
                              pageValue: 1,
                              onPageChange: this.handlePageChange
                            })}
                          >
                            first
                          </button>

                          {hasPreviousPage && (
                            <button
                              {...getPageItemProps({
                                pageValue: previousPage,
                                onPageChange: this.handlePageChange
                              })}
                            >
                              {"<"}
                            </button>
                          )}

                          {pages.map(page => {
                            let activePage = null;
                            if (currentPage === page) {
                              activePage = {
                                backgroundColor: "#ccc",
                                color: "#666"
                              };
                            }
                            return (
                              <button
                                key={page}
                                style={activePage}
                                {...getPageItemProps({
                                  pageValue: page,
                                  onPageChange: this.handlePageChange
                                })}
                              >
                                {page}
                              </button>
                            );
                          })}

                          {hasNextPage && (
                            <button
                              {...getPageItemProps({
                                pageValue: nextPage,
                                onPageChange: this.handlePageChange
                              })}
                            >
                              {">"}
                            </button>
                          )}

                          <button
                            {...getPageItemProps({
                              pageValue: totalPages,
                              onPageChange: this.handlePageChange
                            })}
                          >
                            last
                          </button>
                        </div>
                      )}
                    </Pagination>
                  </div>
                </div>
              </div>
              <div className="clearfix" />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default compose(withRouter)(view);



// WEBPACK FOOTER //
// ./src/app/views/admin/categories/subcategories/view.js